<template>

    <div class="card-week">
        <div :id="'week-'+addWeek">
            <div class="card-week-body">
                <load-spiner v-if="loading"></load-spiner>
                <swiper v-else ref="week-Swiper" :options="swiperOption">
                    <swiper-slide v-for="articulo in orderArticulosOffer" :key="articulo.id">
                        <pedido-edit-item-block @addLineToOrder="addLineToOrder" :articulo="articulo" :add-week="addWeek" :eco="filters.eco"></pedido-edit-item-block>
                    </swiper-slide>
                    <swiper-slide v-for="articulo in orderArticulos" :key="articulo.id">
                        <pedido-edit-item-block @addLineToOrder="addLineToOrder" :articulo="articulo" :add-week="addWeek" :eco="filters.eco"></pedido-edit-item-block>
                    </swiper-slide>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-disponible-prev" slot="button-prev">
                        <div class="swiper-button-disponible"></div>
                    </div>
                    <div class="swiper-button-disponible-next" slot="button-next">
                        <div class="swiper-button-disponible swiper-button-disponible-right"></div>
                    </div>
                </swiper>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: ['filters','addWeek','lineas'],
        data() {
            return {
                articulos: "",
                articulos_offer: "",
                loading: true,
                swiperOption: {
                    slidesPerView: 'auto',
                    spaceBetween: 10,
                    /*centeredSlides: true,*/
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-disponible-next',
                        prevEl: '.swiper-button-disponible-prev'
                    },
                    touchStartPreventDefault: false
                }
            }

        },
        mounted() {
            this.getAvaiableProducts();
        },
        computed: {
            orderArticulos: function () {
                var order='asc';
                if(this.filters.ordenar.length>0){
                    if(this.filters.ordenar[0].id==1){
                        order='asc';
                    }else if(this.filters.ordenar[0].id==2){
                        order='desc';
                    }
                }
                return _.orderBy(this.articulos, ['especie_verify.nombre','nombre_verify'],[order]);
            },
            orderArticulosOffer: function () {
                var order='asc';
                if(this.filters.ordenar.length>0){
                    if(this.filters.ordenar[0].id==1){
                        order='asc';
                    }else if(this.filters.ordenar[0].id==2){
                        order='desc';
                    }
                }
                return _.orderBy(this.articulos_offer, ['especie_verify.nombre','nombre_verify'],[order]);
            }
        },
        methods: {
            getAvaiableProducts: function () {
                this.loading=true;
                axios.post(this.route('products.get.week'), {
                    addWeek: this.addWeek,
                    filters: this.filters,
                    lineas: this.lineas
                }).then(response => {
                    this.articulos = response.data.articulos;
                    this.articulos_offer = response.data.articulos_offer;

                    this.loading = false;
                }).catch(e => {
                    console.log(e);
                });
            },
            addLineToOrder: function(line){
                this.$emit('addLineToOrder',line);
            }
        }
    }
</script>

<style scoped>
.swiper-button-disponible-prev, .swiper-button-disponible-next {
    position: absolute;
    height: 30px;
    width: 30px;
    top: 35%;
    z-index: 10;
    margin-top: -22px;
}

.swiper-button-disponible-prev {
    right: auto;
    left: 20px;
}

.swiper-button-disponible-next {
    right: 20px;
    left: auto;
}

.swiper-button-disabled {
    display: none;
}

.swiper-button-disponible.swiper-button-disponible-right {
    transform: rotate(270deg);
    top: -7px; /* Cuadrar */
}
</style>

<style lang="scss" scoped>
$size: 40px;
$speed: 3s;
$peakopacity:0.9;
$rotate: 90deg;
$red: 0;
$green: 113;
$blue: 188;

.swiper-button-disponible {
    position: absolute; /* Cuadrar */
    top: 7px; /* Cuadrar */
    width:100%;
    height:100%;
    transform:rotate($rotate);
    &:before {
        content: '';
        position: absolute;
        width:100%;
        height:100%;
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size/3,$size*4/3)rotate(-45deg);
        animation: swiper-button-disponible $speed linear infinite;
    }
    &:after {
        content: '';
        position: absolute;
        width:100%;
        height:100%;
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size*2/3,0px)rotate(-45deg) ;
        animation: swiper-button-disponible $speed linear infinite $speed/-2;
    }
}

@keyframes swiper-button-disponible {
    0% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
        transform:translate($size/-6,$size*4/-6)rotate(-45deg) ;
    }
    10%, 90% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
    }
    50% {
        border-left:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        border-bottom:$size/3 solid rgba($red,$green,$blue,$peakopacity);
        transform:translate($size/-6,0px)rotate(-45deg) ;
    }
    100% {
        border-left:$size/3 solid rgba($red,$green,$blue,0);
        border-bottom:$size/3 solid rgba($red,$green,$blue,0);
        transform:translate($size/-6,$size*4/6)rotate(-45deg) ;
    }
}
</style>
